<script>
import CommandeNommer from "@/components/organisms/mon-compte/commande-nommer";
import StateOverlay from "@/components/molecules/state-overlay";
import apiDriveCommande from "@/services/http/api-drive/client/commande";

export default {
  components: {
    CommandeNommer,
    StateOverlay
  },
  props: {
    commande: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ["validate"],
  data() {
    return {
      error: null,
      isLoading: false,
      errorForm: null
    };
  },
  methods: {
    async renameCommande(titre) {
      this.isLoading = true;
      this.error = null;
      try {
        await this.$apiDrive.use(apiDriveCommande).update(this.commande.id, {
          titre
        });
        this.$emit("validate", titre);
      } catch (error) {
        if (error.response && error.response.status !== 422) {
          this.error = this.$apiDrive.getErrorData(error);
        } else {
          this.errorForm = this.$apiDrive.getErrorData(error);
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<template>
  <StateOverlay
    ref="stateOverlay"
    :is-loading="isLoading"
    :error="error"
    :is-error="error !== null"
    size="s"
    overlay
    message="Sauvegarde en cours..."
  >
    <CommandeNommer
      :name="name || commande.attributes.titre"
      :error="errorForm"
      @validate="renameCommande"
    />

  </StateOverlay>
</template>
